// extracted by mini-css-extract-plugin
module.exports = {"title":"az_fOc","separator":"az_gOc"};